import { render, staticRenderFns } from "./errorPage403.vue?vue&type=template&id=4aaaaf10&"
import script from "./errorPage403.vue.ts?vue&type=script&lang=ts&"
export * from "./errorPage403.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports